import React from 'react';
import './PaymentPanel.css';

const PaymentPanel = ({ orderItems }) => {
  const total = orderItems.reduce((sum, item) => {
    return sum + (item.price * item.quantity);
  }, 0);

  return (
    <div className="payment-panel">
      <div className="pay-section">
        <div className="pay-label">Monto</div>
        <div className="pay-amount">${Math.round(total)}</div>
      </div>
    </div>
  );
};

export default PaymentPanel;